module.exports = __webpack_public_path__ + "img/OEM ODM PRODUCTS.44a0e5bd.jpg";